import React, { useCallback, Fragment } from 'react';
import { observer } from 'mobx-react-lite';

import { TutorialPlaylist } from './TutorialPlaylist';
import { TutorialPlaylistHeader } from './TutorialPlaylistHeader';
import { Separator, TimestampList } from '@components';
import { Tutorial } from '@models/Tutorials/TutorialModel';
import { TimestampsListHeader } from './TimestampsListHeader';
import type { ITutorialScreenStore } from '../TutorialScreen';
import { TutorialTimestamp } from '@models/Tutorials/TutorialTimestampModel';
import { Course } from '@models/Courses/CourseModel';
import { CoursePlaylist } from './CoursePlaylist';
import { CoursePlaylistHeader } from './CoursePlaylistHeader';
export interface ISideListProps {
  tutorial: Tutorial;
  course: Course | undefined;
  screenStore: ITutorialScreenStore;
  onSelectTimestamp(item: TutorialTimestamp): void;
}

export const SideList = observer<ISideListProps>(
  ({ tutorial, course, screenStore, onSelectTimestamp }) => {
    const TimestampsListHeaderComponent = useCallback(
      () => (
        <Fragment>
          <TimestampsListHeader
            onPressClose={screenStore.toggleIsShowTimestamps}
          />
          <Separator />
        </Fragment>
      ),
      [],
    );

    const PlayListHeaderComponent = useCallback(
      () => (
        <Fragment>
          {course ? (
            <CoursePlaylistHeader course={course} />
          ) : (
            <TutorialPlaylistHeader />
          )}
          <Separator />
        </Fragment>
      ),
      [tutorial, course],
    );

    if (screenStore.isShowTimestamps) {
      return (
        <TimestampList
          ListHeaderComponent={TimestampsListHeaderComponent}
          tutorial={tutorial}
          onPress={onSelectTimestamp}
        />
      );
    }

    return course ? (
      <CoursePlaylist
        course={course}
        ListHeaderComponent={PlayListHeaderComponent}
      />
    ) : (
      <TutorialPlaylist
        tutorial={tutorial}
        ListHeaderComponent={PlayListHeaderComponent}
      />
    );
  },
);
